import axiosInstance from "./api_helper";

const invoiceService = {
    list: async ({ clientId, dateFrom, dateTo, query, amount, page, size } = {}) => {
        const params = {};
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (query) params.query = query;
        if (amount !== undefined && amount !== null && amount !== '') params.amount = amount;
        if (page !== undefined && page !== null) params.page = page;
        if (size !== undefined && size !== null) params.size = size;

        const response = await axiosInstance.get('/api/ventes/factures', { params });
        return response.data;
    },

    listImpayes: async ({ clientId }) => {
        try {
            const params = {};
            if (clientId !== undefined && clientId !== null) params.clientId = clientId;
            const response = await axiosInstance.get('/api/ventes/factures/impaye', { params });

            return response.data;
        } catch (error) {
            console.error('Error fetching invoices with sub-invoices:', error);
            throw error;
        }
    },

    getNewInvoiceNumber: async ({ dateFacture, date } = {}) => {
        const params = {};
        if (dateFacture || date) params.date = dateFacture || date;

        return await axiosInstance.get('/api/ventes/facture/generate-number', { params });
    },

    addInvoice: async (invoiceData) => {
        return await axiosInstance.post('/api/ventes/facture/creer', invoiceData);
    },

    addPayment: async (paymentData) => {
        return await axiosInstance.post('/api/payments', paymentData);
    },

    generatePdf: async (invoiceDTO) => {
        const response = await axiosInstance.post(`/api/invoices/report`, invoiceDTO, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },

    deleteInvoice: async (invoiceId) => {
        const response = await axiosInstance.delete(`/api/invoices/${invoiceId}`);
        return response.data;
    },

    filterInvoice: async (query) => {
        return axiosInstance.post(`/api/invoices/search`, JSON.stringify(query));
    },

    getLastSavedInvoice: async () => {
        return await axiosInstance.get(`/api/invoices/last-saved`);
    },

    listWithSubInvoices: async ({ clientId, dateFrom, dateTo, query, amount, page, size } = {}) => {
        try {
            const params = {};
            if (clientId !== undefined && clientId !== null) params.clientId = clientId;
            if (dateFrom) params.dateFrom = dateFrom;
            if (dateTo) params.dateTo = dateTo;
            if (query) params.query = query;
            if (amount !== undefined && amount !== null && amount !== '') params.amount = amount;
            if (page !== undefined && page !== null) params.page = page;
            if (size !== undefined && size !== null) params.size = size;

            const response = await axiosInstance.get('/api/ventes/factures', { params });

            return response.data;
        } catch (error) {
            console.error('Error fetching invoices with sub-invoices:', error);
            throw error;
        }
    },

    getFactureTotals: async ({ clientId, dateFrom, dateTo, query, amount } = {}) => {
        const params = {};
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (query) params.query = query;
        if (amount !== undefined && amount !== null && amount !== '') params.amount = amount;

        const response = await axiosInstance.get('/api/ventes/factures/totals', { params });
        return response.data;
    },

    createSubInvoices: async (subInvoiceData) => {
        try {
            const response = await axiosInstance.post('/api/ventes/factures/create-sub-invoices', subInvoiceData);
            return response.data;
        } catch (error) {
            console.error('Error creating sub-invoices:', error);
            throw error;
        }
    },

    getSubInvoicesByParentId: async (parentInvoiceId) => {
        try {
            const response = await axiosInstance.get(`/api/ventes/factures/${parentInvoiceId}/sous-factures`);
            return response.data;
        } catch (error) {
            console.error('Error fetching sub-invoices:', error);
            throw error;
        }
    },

    updateSubInvoice: async (subInvoiceId, subInvoiceData) => {
        try {
            const response = await axiosInstance.put(`/api/ventes/sous-factures/${subInvoiceId}`, subInvoiceData);
            return response.data;
        } catch (error) {
            console.error('Error updating sub-invoice:', error);
            throw error;
        }
    },

    deleteSubInvoice: async (subInvoiceId) => {
        try {
            const response = await axiosInstance.delete(`/api/ventes/sous-factures/${subInvoiceId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting sub-invoice:', error);
            throw error;
        }
    },

    getNewSubInvoiceNumber: async (parentInvoiceId) => {
        return await axiosInstance.get(`/api/ventes/factures/${parentInvoiceId}/generate-sub-invoice-number`);
    },

    updateInvoice: async (invoiceId, invoiceData) => {
        return await axiosInstance.put(`/api/ventes/factures/${invoiceId}`, JSON.stringify(invoiceData));
    },

    cancelInvoice: async (invoiceId, motifAnnulation) => {
        try {
            const response = await axiosInstance.post(`/api/ventes/factures/${invoiceId}/annuler?motifAnnulation=${encodeURIComponent(motifAnnulation)}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    canBeUpdated: async (invoiceId) => {
        try {
            const response = await axiosInstance.get(`/api/ventes/factures/${invoiceId}/can-update`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getInvoiceById: async (invoiceId) => {
        try {
            const response = await axiosInstance.get(`/api/ventes/factures/${invoiceId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },


    // Statistics for invoices with sub-invoices
    getInvoiceStatistics: async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();

            if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
            if (params.dateTo) queryParams.append('dateTo', params.dateTo);
            if (params.clientId) queryParams.append('clientId', params.clientId);
            if (params.includeSubInvoices !== undefined) queryParams.append('includeSubInvoices', params.includeSubInvoices);

            const response = await axiosInstance.get(`/api/ventes/factures/statistics?${queryParams.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching invoice statistics:', error);
            throw error;
        }
    },

    // Sub-invoice specific methods
    getSubInvoiceById: async (subInvoiceId) => {
        try {
            const response = await axiosInstance.get(`/api/ventes/sous-factures/${subInvoiceId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching sub-invoice:', error);
            throw error;
        }
    },

    getOverdueSubInvoices: async () => {
        try {
            const response = await axiosInstance.get('/api/ventes/sous-factures/overdue');
            return response.data;
        } catch (error) {
            console.error('Error fetching overdue sub-invoices:', error);
            throw error;
        }
    },

    getSubInvoicesDueSoon: async (days = 7) => {
        try {
            const response = await axiosInstance.get(`/api/ventes/sous-factures/due-soon?days=${days}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching sub-invoices due soon:', error);
            throw error;
        }
    },

    getSubInvoiceStatistics: async (factureParentId) => {
        try {
            const response = await axiosInstance.get(`/api/ventes/sous-factures/statistics/${factureParentId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching sub-invoice statistics:', error);
            throw error;
        }
    },

    addPaymentToSubInvoice: async (subInvoiceId, paymentData) => {
        try {
            const response = await axiosInstance.post(`/api/ventes/sous-factures/${subInvoiceId}/payment`, paymentData);
            return response.data;
        } catch (error) {
            console.error('Error adding payment to sub-invoice:', error);
            throw error;
        }
    }

}

export default invoiceService;
